import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i2 from 'base-petitioner-details-library';
import { BasePetitionerDetailsLibraryService } from 'base-petitioner-details-library';
import * as i10 from '@angular/forms';
import { ControlContainer, NgForm } from '@angular/forms';
import { Subject } from 'rxjs/internal/Subject';
import { first } from 'rxjs/internal/operators/first';
import * as i1 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'dirty-check-store';
import * as i6 from 'primeng/dynamicdialog';
import * as i7 from 'app-services-library';
import * as i8 from '@angular/common';
import * as i9 from 'in-care-of-name';
import { InCareOfNameModule } from 'in-care-of-name';
import * as i11 from 'primeng/divider';
import * as i12 from 'primeng/button';
import * as i13 from 'primeng/tooltip';
import * as i14 from 'primeng/card';
import * as i15 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import * as i16 from 'maximize-dialog-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import * as i17 from 'assigning-task-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import * as i18 from 'last-update-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import * as i19 from 'editor-library';
import { EditorLibraryModule } from 'editor-library';
import * as i20 from 'send-back-component-library';
import { SendBackComponentLibraryModule } from 'send-back-component-library';
import * as i21 from 'notification-component-library';
import { NotificationComponentLibraryModule } from 'notification-component-library';
import * as i22 from 'file-upload-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import { PrimengLibraryModule } from 'primeng-library';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { DeleteDialogLibraryModule } from 'delete-dialog-library';

class PetitionerDetailsLibraryService {
    constructor() { }
}
PetitionerDetailsLibraryService.ɵfac = function PetitionerDetailsLibraryService_Factory(t) { return new (t || PetitionerDetailsLibraryService)(); };
PetitionerDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: PetitionerDetailsLibraryService, factory: PetitionerDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PetitionerDetailsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["petitionerDocumentForm"];
function PetitionerDetailsLibraryComponent_div_1_h5_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "(US Company)");
    i0.ɵɵelementEnd();
} }
function PetitionerDetailsLibraryComponent_div_1_h5_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 19);
    i0.ɵɵtext(1, " Petitioner Details & Documents");
    i0.ɵɵtemplate(2, PetitionerDetailsLibraryComponent_div_1_h5_2_span_2_Template, 2, 0, "span", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r11.inputData.visatype != "H1-B");
} }
function PetitionerDetailsLibraryComponent_div_1_h5_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 19);
    i0.ɵɵtext(1, " Petitioner Details & Documents(Foreign Company)");
    i0.ɵɵelementEnd();
} }
const _c1 = function (a0) { return { "layoutCode": a0 }; };
function PetitionerDetailsLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "div", 34);
    i0.ɵɵtemplate(2, PetitionerDetailsLibraryComponent_div_1_h5_2_Template, 3, 1, "h5", 35);
    i0.ɵɵtemplate(3, PetitionerDetailsLibraryComponent_div_1_h5_3_Template, 2, 0, "h5", 35);
    i0.ɵɵelementStart(4, "p", 19);
    i0.ɵɵtext(5, "Upload supporting petitioner documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 36);
    i0.ɵɵelementStart(7, "ul");
    i0.ɵɵelementStart(8, "li", 37);
    i0.ɵɵelement(9, "lib-step-status-update-component-library", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "li", 39);
    i0.ɵɵelement(11, "lib-maximize-dialog-library", 40);
    i0.ɵɵelementStart(12, "i", 41);
    i0.ɵɵlistener("click", function PetitionerDetailsLibraryComponent_div_1_Template_i_click_12_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.isForeignCompany);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isForeignCompany);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("visaType", ctx_r0.inputData.caseType != "I130" ? ctx_r0.inputData.visatype : ctx_r0.inputData.caseType)("stepDetails", ctx_r0.stepDetails)("isViewMode", ctx_r0.inputData["isViewMode"])("isCaseRequest", ctx_r0.inputData["isCaseRequest"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(7, _c1, ctx_r0.inputData == null ? null : ctx_r0.inputData.layoutCode));
} }
function PetitionerDetailsLibraryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "lib-assigning-task-library", 43);
    i0.ɵɵlistener("updateStatus", function PetitionerDetailsLibraryComponent_div_2_Template_lib_assigning_task_library_updateStatus_2_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.updateStepStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("visaType", ctx_r1.inputData.visatype)("stepDetails", ctx_r1.stepDetails)("isViewMode", ctx_r1.inputData["isViewMode"])("isCaseRequest", ctx_r1.inputData["isCaseRequest"]);
} }
function PetitionerDetailsLibraryComponent_p_divider_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 44);
} }
function PetitionerDetailsLibraryComponent_lib_last_update_library_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-last-update-library", 45);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("inputDetails", ctx_r3.stepDetails)("primaryData", ctx_r3.inputData);
} }
function PetitionerDetailsLibraryComponent_div_50_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "Entities Relationship Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 47);
    i0.ɵɵelement(4, "lib-editor-library", 48);
    i0.ɵɵelementStart(5, "button", 49);
    i0.ɵɵlistener("click", function PetitionerDetailsLibraryComponent_div_50_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.postPetitionerDocument(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(8);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("events", ctx_r5.onSaveEmitSubject.asObservable())("primaryData", ctx_r5.inputData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", _r4.invalid || ctx_r5.disabledControls ? "btn-success button-width-icon-left mr-3 mt-2 btn-success_disabled" : "btn-success button-width-icon-left mt-2 mr-3")("disabled", _r4.invalid || ctx_r5.disabledControls);
} }
function PetitionerDetailsLibraryComponent_div_77_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r20.fileName, " ");
} }
function PetitionerDetailsLibraryComponent_div_77_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 54);
    i0.ɵɵelement(1, "i", 55);
    i0.ɵɵtext(2, " Document Missing ");
    i0.ɵɵelementEnd();
} }
function PetitionerDetailsLibraryComponent_div_77_div_7_lib_send_back_component_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-send-back-component", 60);
} if (rf & 2) {
    const item_r20 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r27 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabledControls", ctx_r27.disabledControls)("stepDetails", ctx_r27.stepDetails)("primaryData", ctx_r27.primaryData)("item", item_r20);
} }
function PetitionerDetailsLibraryComponent_div_77_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵelementStart(1, "button", 57);
    i0.ɵɵlistener("click", function PetitionerDetailsLibraryComponent_div_77_div_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r31); const item_r20 = i0.ɵɵnextContext().$implicit; const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.openDoc(item_r20); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, PetitionerDetailsLibraryComponent_div_77_div_7_lib_send_back_component_2_Template, 1, 4, "lib-send-back-component", 58);
    i0.ɵɵelementStart(3, "button", 59);
    i0.ɵɵlistener("click", function PetitionerDetailsLibraryComponent_div_77_div_7_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r31); const item_r20 = i0.ɵɵnextContext().$implicit; const ctx_r32 = i0.ɵɵnextContext(); return ctx_r32.deleteImmigrationDocuments(item_r20); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = i0.ɵɵnextContext().$implicit;
    const ctx_r24 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !item_r20.fileLocation);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r24.userType !== "Beneficiary" && ctx_r24.userType !== "Petitioner");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r24.disabledControls);
} }
function PetitionerDetailsLibraryComponent_div_77_div_8_notification_component_library_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "notification-component-library", 62);
} if (rf & 2) {
    const item_r20 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r35 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabledControls", ctx_r35.disabledControls)("stepDetails", ctx_r35.stepDetails)("destination", ctx_r35.notifyDestinationUser)("primaryData", ctx_r35.primaryData)("item", item_r20);
} }
function PetitionerDetailsLibraryComponent_div_77_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, PetitionerDetailsLibraryComponent_div_77_div_8_notification_component_library_1_Template, 1, 5, "notification-component-library", 61);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r25.userType !== "Beneficiary" && ctx_r25.userType !== "Petitioner");
} }
function PetitionerDetailsLibraryComponent_div_77_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 50);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 29);
    i0.ɵɵtemplate(5, PetitionerDetailsLibraryComponent_div_77_span_5_Template, 2, 1, "span", 32);
    i0.ɵɵtemplate(6, PetitionerDetailsLibraryComponent_div_77_span_6_Template, 3, 0, "span", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PetitionerDetailsLibraryComponent_div_77_div_7_Template, 4, 3, "div", 52);
    i0.ɵɵtemplate(8, PetitionerDetailsLibraryComponent_div_77_div_8_Template, 2, 1, "div", 53);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (item_r20 == null ? null : item_r20.fileCategory.code) === "OTHER" && item_r20.isPresent ? item_r20.fileCtaegoryOtherName : item_r20 == null ? null : item_r20.fileCategory.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r20.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r20.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r20 == null ? null : item_r20.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(item_r20 == null ? null : item_r20.isPresent));
} }
function PetitionerDetailsLibraryComponent_div_78_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, " No documents found ");
    i0.ɵɵelementEnd();
} }
function PetitionerDetailsLibraryComponent_div_80_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "(US Company)");
    i0.ɵɵelementEnd();
} }
function PetitionerDetailsLibraryComponent_div_80_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 63);
    i0.ɵɵelementStart(2, "div", 20);
    i0.ɵɵelementStart(3, "h5", 64);
    i0.ɵɵtext(4, "Upload any additional required documents ");
    i0.ɵɵtemplate(5, PetitionerDetailsLibraryComponent_div_80_span_5_Template, 2, 0, "span", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 42);
    i0.ɵɵelementStart(7, "div", 25);
    i0.ɵɵelement(8, "file-upload-library", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r8.inputData.visatype != "H1-B");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("fileUploadConfigurations", ctx_r8.fileUploadUSConfigurations);
} }
function PetitionerDetailsLibraryComponent_div_82_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelementStart(2, "div", 20);
    i0.ɵɵelementStart(3, "h5", 66);
    i0.ɵɵtext(4, "Petitioner Documents (Foreign Company)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 42);
    i0.ɵɵelementStart(6, "div", 25);
    i0.ɵɵelement(7, "file-upload-library", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("fileUploadConfigurations", ctx_r9.fileUploadForeignConfigurations);
} }
function PetitionerDetailsLibraryComponent_div_84_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelement(1, "div", 20);
    i0.ɵɵelementStart(2, "div", 67);
    i0.ɵɵelement(3, "lib-step-status-update-component-library", 68);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("isViewMode", ctx_r10.inputData["isViewMode"])("isCaseRequest", ctx_r10.inputData["isCaseRequest"])("visaType", ctx_r10.inputData.caseType != "I130" ? ctx_r10.inputData.visatype : ctx_r10.inputData.caseType)("stepDetails", ctx_r10.stepDetails)("type", ctx_r10.typeOfButton)("showPreviousStepBtn", ctx_r10.showPrev)("showNextStepBtn", ctx_r10.showNext);
} }
class PetitionerDetailsLibraryComponent extends BasePetitionerDetailsLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, dialogService, appServicesLibraryService) {
        super(store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, dialogService, appServicesLibraryService);
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.dialogService = dialogService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.onSaveEmitSubject = new Subject();
        this.isSimplifyH1B = false;
        this.onDialogClose = new EventEmitter();
        this.showNext = false;
        this.showPrev = false;
    }
    ngOnInit() {
        var _a, _b;
        this.isForeignCompany = this.isForeignCompany;
        this.inputData = this.primaryData;
        this.showNext = (_a = this.inputData) === null || _a === void 0 ? void 0 : _a.showNext;
        this.showPrev = (_b = this.inputData) === null || _b === void 0 ? void 0 : _b.showPrev;
        super.loadInit();
    }
    ngAfterViewInit() {
        this.petitionerDocumentForm = this.petitionerDocumentForm;
        super.afterViewInit();
    }
    postPetitionerDocument() {
        this.onSaveEmitSubject.next();
        super.postFormSubmission();
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.onDialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
PetitionerDetailsLibraryComponent.ɵfac = function PetitionerDetailsLibraryComponent_Factory(t) { return new (t || PetitionerDetailsLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.APIPetitionerDetails), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.DirtyFormGuard), i0.ɵɵdirectiveInject(i6.DialogService), i0.ɵɵdirectiveInject(i7.AppServicesLibraryService)); };
PetitionerDetailsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PetitionerDetailsLibraryComponent, selectors: [["petitioner-details-library"]], viewQuery: function PetitionerDetailsLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.petitionerDocumentForm = _t.first);
    } }, inputs: { isSimplifyH1B: "isSimplifyH1B", isForeignCompany: "isForeignCompany", primaryData: "primaryData" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵProvidersFeature([], [{ provide: ControlContainer, useExisting: NgForm }]), i0.ɵɵInheritDefinitionFeature], decls: 85, vars: 21, consts: [[1, "fluid-container"], ["class", "row pt-4 d-flex align-items-center", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "header-divider", 4, "ngIf"], [1, "main-body", "footer-adjust-v2"], ["sectionCode", "PETITIONER_DOCS", 3, "inputDetails", "primaryData", 4, "ngIf"], [3, "inputData", "petitionId", "disabledControls"], ["petitionerDocumentForm", "ngForm"], [1, "row", "col-md-12", "pt-3", "pb-3"], [1, "sub-title"], [1, "row", "pb-3"], [1, "col"], [1, "label-cls"], [1, "readOnly-label"], [1, "col-md-4"], [1, "row", "pb-4"], ["class", "row col-md-12  profile-title pt-3", 4, "ngIf"], [1, "row", "col-md-12", "p-0", "pt-2", "d-flex", "align-items-center"], [1, "col-md-9", "step-title"], [1, "mb-0"], [1, "col-md-6"], [1, "col-md-6", "sync-btn"], ["type", "button", "pButton", "", "pTooltip", "Sync From Company Profile", 1, "p-button-text", "pull-right", "p-button-outlined", 3, "disabled", "click"], [1, "pi", "pi-check"], [1, "row", "mt-2"], [1, "col-md-12", "p-0"], [1, "courseList", "col-md-12", "p-0"], [1, "courses-card"], [1, "row", "document-header"], [1, "col-md-5"], [1, "col-md-2"], ["class", "row document  courses-title d-flex align-items-center", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "row", "pt-4", "d-flex", "align-items-center"], [1, "col-md-8", "step-title"], ["class", "mb-0", 4, "ngIf"], [1, "col-md-4", "editBtn", "headerSubPortion", "px-0"], [1, "col-auto", "px-0", "firstPortion"], ["type", "EDIT", 1, "float-right", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest"], [1, "col-auto", "pr-0", "pl-2", "secondPortion"], [3, "configData"], [1, "close-icon", "pi", "pi-times", "pull-right", 3, "click"], [1, "row"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus"], [1, "header-divider"], ["sectionCode", "PETITIONER_DOCS", 3, "inputDetails", "primaryData"], [1, "row", "col-md-12", "profile-title", "pt-3"], [1, "col-md-12", "pl-0", "pr-0", "beneficiary-experience-froala-editor"], ["infoName", "Petition Letter List", "infoType", "PTLTRLIST", 3, "events", "primaryData"], ["pButton", "", "type", "submit", "label", "Save", "icon", "pi pi-save", 3, "ngClass", "disabled", "click"], [1, "row", "document", "courses-title", "d-flex", "align-items-center"], ["class", "redColor d-flex align-items-center", 4, "ngIf"], ["class", "col-md-2 pull-right d-flex align-items-center", 4, "ngIf"], ["class", "col-md-2", 4, "ngIf"], [1, "redColor", "d-flex", "align-items-center"], [1, "pi", "pi-exclamation-triangle", "pr-2"], [1, "col-md-2", "pull-right", "d-flex", "align-items-center"], ["pButton", "", "type", "button", "icon", "pi pi-eye", "pTooltip", "View", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], [3, "disabledControls", "stepDetails", "primaryData", "item", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", 2, "color", "#75777A", 3, "disabled", "click"], [3, "disabledControls", "stepDetails", "primaryData", "item"], [3, "disabledControls", "stepDetails", "destination", "primaryData", "item", 4, "ngIf"], [3, "disabledControls", "stepDetails", "destination", "primaryData", "item"], [1, "row", "col-md-12", "p-0", "pt-4", "d-flex", "align-items-center"], [1, "sub-title", "pb-3"], [2, "width", "100%", 3, "fileUploadConfigurations"], [1, "sub-title", "pb-5"], [1, "col-md-6", "completeStep"], [1, "d-flex", "col-12", "justify-content-end", 3, "isViewMode", "isCaseRequest", "visaType", "stepDetails", "type", "showPreviousStepBtn", "showNextStepBtn"]], template: function PetitionerDetailsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PetitionerDetailsLibraryComponent_div_1_Template, 13, 9, "div", 1);
        i0.ɵɵtemplate(2, PetitionerDetailsLibraryComponent_div_2_Template, 3, 4, "div", 2);
        i0.ɵɵtemplate(3, PetitionerDetailsLibraryComponent_p_divider_3_Template, 1, 0, "p-divider", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, PetitionerDetailsLibraryComponent_lib_last_update_library_5_Template, 1, 2, "lib-last-update-library", 5);
        i0.ɵɵelement(6, "lib-in-care-of-name", 6);
        i0.ɵɵelementStart(7, "form", null, 7);
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵelementStart(10, "h5", 9);
        i0.ɵɵtext(11, "Petitioner Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 10);
        i0.ɵɵelementStart(13, "div", 11);
        i0.ɵɵelementStart(14, "label", 12);
        i0.ɵɵtext(15, "Employer Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 13);
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 10);
        i0.ɵɵelementStart(19, "div", 14);
        i0.ɵɵelementStart(20, "label", 12);
        i0.ɵɵtext(21, "Address Line 1");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 13);
        i0.ɵɵtext(23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 14);
        i0.ɵɵelementStart(25, "label", 12);
        i0.ɵɵtext(26, "Address Line 2");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 13);
        i0.ɵɵtext(28);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 14);
        i0.ɵɵelementStart(30, "label", 12);
        i0.ɵɵtext(31, "Country");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 13);
        i0.ɵɵtext(33);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "div", 15);
        i0.ɵɵelementStart(35, "div", 14);
        i0.ɵɵelementStart(36, "label", 12);
        i0.ɵɵtext(37, "State");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 13);
        i0.ɵɵtext(39);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(40, "div", 14);
        i0.ɵɵelementStart(41, "label", 12);
        i0.ɵɵtext(42, "City");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "div", 13);
        i0.ɵɵtext(44);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "div", 14);
        i0.ɵɵelementStart(46, "label", 12);
        i0.ɵɵtext(47, "ZIP / Postal Code");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(48, "div", 13);
        i0.ɵɵtext(49);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(50, PetitionerDetailsLibraryComponent_div_50_Template, 6, 4, "div", 16);
        i0.ɵɵelement(51, "p-divider");
        i0.ɵɵelementStart(52, "div", 17);
        i0.ɵɵelementStart(53, "div", 18);
        i0.ɵɵelementStart(54, "h5", 19);
        i0.ɵɵtext(55, "Petitioner Documents");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(56, "div", 20);
        i0.ɵɵelementStart(57, "h5", 9);
        i0.ɵɵtext(58, "Default documents from Company Profile");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(59, "div", 21);
        i0.ɵɵelementStart(60, "button", 22);
        i0.ɵɵlistener("click", function PetitionerDetailsLibraryComponent_Template_button_click_60_listener() { return ctx.syncPetitionerDocuments(); });
        i0.ɵɵelement(61, "i", 23);
        i0.ɵɵtext(62, "\u00A0\u00A0\u00A0");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(63, "div", 24);
        i0.ɵɵelementStart(64, "div", 25);
        i0.ɵɵelementStart(65, "div", 26);
        i0.ɵɵelementStart(66, "p-card", 27);
        i0.ɵɵelementStart(67, "div", 28);
        i0.ɵɵelementStart(68, "div", 29);
        i0.ɵɵelementStart(69, "h6");
        i0.ɵɵtext(70, "Document Type");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(71, "div", 29);
        i0.ɵɵelementStart(72, "h6");
        i0.ɵɵtext(73, "Document Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(74, "div", 30);
        i0.ɵɵelementStart(75, "h6");
        i0.ɵɵtext(76, "Action");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(77, PetitionerDetailsLibraryComponent_div_77_Template, 9, 5, "div", 31);
        i0.ɵɵtemplate(78, PetitionerDetailsLibraryComponent_div_78_Template, 2, 0, "div", 32);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(79, "p-divider");
        i0.ɵɵtemplate(80, PetitionerDetailsLibraryComponent_div_80_Template, 9, 2, "div", 32);
        i0.ɵɵelement(81, "p-divider");
        i0.ɵɵtemplate(82, PetitionerDetailsLibraryComponent_div_82_Template, 8, 1, "div", 32);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(83, "p-divider");
        i0.ɵɵtemplate(84, PetitionerDetailsLibraryComponent_div_84_Template, 4, 7, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isSimplifyH1B);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isSimplifyH1B);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isSimplifyH1B);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isSimplifyH1B);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("inputData", ctx.inputData)("petitionId", ctx.inputData.caseId)("disabledControls", ctx.disabledControls);
        i0.ɵɵadvance(11);
        i0.ɵɵtextInterpolate(ctx.petitionerDetails == null ? null : ctx.petitionerDetails.companyName);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(ctx.petitionerDetails == null ? null : ctx.petitionerDetails.address[0] == null ? null : ctx.petitionerDetails.address[0].addressLine1);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.petitionerDetails == null ? null : ctx.petitionerDetails.address[0] == null ? null : ctx.petitionerDetails.address[0].addressLine2);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.petitionerDetails == null ? null : ctx.petitionerDetails.address[0] == null ? null : ctx.petitionerDetails.address[0].countryName);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(ctx.petitionerDetails == null ? null : ctx.petitionerDetails.address[0] == null ? null : ctx.petitionerDetails.address[0].state);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.petitionerDetails == null ? null : ctx.petitionerDetails.address[0] == null ? null : ctx.petitionerDetails.address[0].city);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.petitionerDetails == null ? null : ctx.petitionerDetails.address[0] == null ? null : ctx.petitionerDetails.address[0].postCode);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isForeignCompany && ctx.inputData.visatype != "H1-B");
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(17);
        i0.ɵɵproperty("ngForOf", ctx.h1BPetitionerDocumentList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.petitionerDocumentList.length <= 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isForeignCompany);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isForeignCompany);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isSimplifyH1B);
    } }, directives: [i8.NgIf, i9.InCareOfNameComponent, i10.ɵangular_packages_forms_forms_ba, i10.NgControlStatusGroup, i10.NgForm, i11.Divider, i12.ButtonDirective, i13.Tooltip, i14.Card, i8.NgForOf, i15.StepStatusUpdateComponentLibraryComponent, i16.MaximizeDialogLibraryComponent, i17.AssigningTaskLibraryComponent, i18.LastUpdateLibraryComponent, i19.EditorLibraryComponent, i8.NgClass, i20.SendBackComponentLibraryComponent, i21.NotificationComponentLibrary, i22.FileUploadLibraryComponent], styles: [".label-cls[_ngcontent-%COMP%]{font:normal normal 300 14px/20px Source Sans Pro;letter-spacing:0;color:#4a4a4a}.readOnly-label[_ngcontent-%COMP%]{width:100%;font:normal normal normal 16px/22px Source Sans Pro;color:#4a4a4a}.requiredFields[_ngcontent-%COMP%]{color:red}.sub-title[_ngcontent-%COMP%]{margin-bottom:0;font:normal normal 600 18px/25px Source Sans Pro;color:#465f7c}.sync-btn[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-weight:600;border-color:#19a0da!important;font:normal normal 700 14px/20px Source Sans Pro!important;color:#19a0da!important;text-transform:uppercase!important}.save-btn[_ngcontent-%COMP%]{background-color:#19a0da;padding:10px 30px!important;font-size:14px!important;border-radius:8px!important}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font:normal normal 700 22px/32px Source Sans Pro;color:#3d3d63}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font:normal normal normal 16px/22px Source Sans Pro;color:#626262}.courseList[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:normal normal 600 14px/20px Source Sans Pro;color:#4a4a4a}.courseList[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font:normal normal normal 14px/21px Source Sans Pro;color:#4a4a4a}.pi-check[_ngcontent-%COMP%]:before{content:url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2223.5%22 height%3D%2217.66%22 viewBox%3D%220 0 23.5 17.66%22%3E  %3Cg id%3D%22Group_306%22 data-name%3D%22Group 306%22 transform%3D%22translate(-835.271 -201.546)%22%3E    %3Cg id%3D%22Group_301%22 data-name%3D%22Group 301%22%3E      %3Cg id%3D%22Group_300%22 data-name%3D%22Group 300%22%3E        %3Cg id%3D%22Group_299%22 data-name%3D%22Group 299%22%3E          %3Cg id%3D%22Group_298%22 data-name%3D%22Group 298%22%3E            %3Cpath id%3D%22Path_208%22 data-name%3D%22Path 208%22 d%3D%22M839.048%2C211.877a.75.75%2C0%2C0%2C1-.746-.684c-.027-.307-.04-.566-.04-.816a8.83%2C8.83%2C0%2C0%2C1%2C14.949-6.368.75.75%2C0%2C1%2C1-1.039%2C1.082%2C7.33%2C7.33%2C0%2C0%2C0-12.409%2C5.286c0%2C.2.011.422.034.684a.75.75%2C0%2C0%2C1-.681.813Z%22 fill%3D%22%2330b1e1%22%2F%3E          %3C%2Fg%3E        %3C%2Fg%3E      %3C%2Fg%3E      %3Cpath id%3D%22Path_209%22 data-name%3D%22Path 209%22 d%3D%22M838.8%2C212.45a.749.749%2C0%2C0%2C1-.6-.294l-2.776-3.622a.75.75%2C0%2C0%2C1%2C1.191-.912l2.321%2C3.028%2C3.038-2.315a.75.75%2C0%2C0%2C1%2C.909%2C1.193l-3.633%2C2.768A.747.747%2C0%2C0%2C1%2C838.8%2C212.45Z%22 fill%3D%22%2330b1e1%22%2F%3E    %3C%2Fg%3E    %3Cg id%3D%22Group_305%22 data-name%3D%22Group 305%22%3E      %3Cg id%3D%22Group_304%22 data-name%3D%22Group 304%22%3E        %3Cg id%3D%22Group_303%22 data-name%3D%22Group 303%22%3E          %3Cg id%3D%22Group_302%22 data-name%3D%22Group 302%22%3E            %3Cpath id%3D%22Path_210%22 data-name%3D%22Path 210%22 d%3D%22M846.948%2C219.206a8.787%2C8.787%2C0%2C0%2C1-6.116-2.463.75.75%2C0%2C1%2C1%2C1.039-1.082%2C7.33%2C7.33%2C0%2C0%2C0%2C12.409-5.286c0-.2-.011-.422-.034-.684a.75.75%2C0%2C0%2C1%2C1.494-.132c.027.307.04.567.04.816A8.842%2C8.842%2C0%2C0%2C1%2C846.948%2C219.206Z%22 fill%3D%22%2330b1e1%22%2F%3E          %3C%2Fg%3E        %3C%2Fg%3E      %3C%2Fg%3E      %3Cpath id%3D%22Path_211%22 data-name%3D%22Path 211%22 d%3D%22M858.022%2C213.424a.749.749%2C0%2C0%2C1-.6-.294l-2.32-3.028-3.038%2C2.315a.75.75%2C0%2C0%2C1-.909-1.193l3.633-2.768a.75.75%2C0%2C0%2C1%2C1.05.14l2.775%2C3.622a.75.75%2C0%2C0%2C1-.595%2C1.206Z%22 fill%3D%22%2330b1e1%22%2F%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E\")!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PetitionerDetailsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'petitioner-details-library',
                templateUrl: 'petitioner-details-library.component.html',
                styleUrls: ['petitioner-details-library.component.scss'],
                viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.APIPetitionerDetails }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.DirtyFormGuard }, { type: i6.DialogService }, { type: i7.AppServicesLibraryService }]; }, { isSimplifyH1B: [{
            type: Input
        }], isForeignCompany: [{
            type: Input
        }], primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], petitionerDocumentForm: [{
            type: ViewChild,
            args: ['petitionerDocumentForm', { static: true }]
        }] }); })();

class PetitionerDetailsLibraryModule {
}
PetitionerDetailsLibraryModule.ɵfac = function PetitionerDetailsLibraryModule_Factory(t) { return new (t || PetitionerDetailsLibraryModule)(); };
PetitionerDetailsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: PetitionerDetailsLibraryModule });
PetitionerDetailsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BasePetitionerDetailsLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            FileUploadLibraryModule,
            FroalaEditorModule,
            FroalaViewModule,
            NotificationComponentLibraryModule,
            SendBackComponentLibraryModule,
            DeleteDialogLibraryModule,
            EditorLibraryModule,
            LastUpdateLibraryModule,
            AssigningTaskLibraryModule,
            InCareOfNameModule,
            MaximizeDialogLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PetitionerDetailsLibraryModule, { declarations: [PetitionerDetailsLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        FileUploadLibraryModule,
        FroalaEditorModule,
        FroalaViewModule,
        NotificationComponentLibraryModule,
        SendBackComponentLibraryModule,
        DeleteDialogLibraryModule,
        EditorLibraryModule,
        LastUpdateLibraryModule,
        AssigningTaskLibraryModule,
        InCareOfNameModule,
        MaximizeDialogLibraryModule], exports: [PetitionerDetailsLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PetitionerDetailsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [PetitionerDetailsLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    FileUploadLibraryModule,
                    FroalaEditorModule,
                    FroalaViewModule,
                    NotificationComponentLibraryModule,
                    SendBackComponentLibraryModule,
                    DeleteDialogLibraryModule,
                    EditorLibraryModule,
                    LastUpdateLibraryModule,
                    AssigningTaskLibraryModule,
                    InCareOfNameModule,
                    MaximizeDialogLibraryModule
                ],
                providers: [BasePetitionerDetailsLibraryService],
                exports: [PetitionerDetailsLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of petitioner-details-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PetitionerDetailsLibraryComponent, PetitionerDetailsLibraryModule, PetitionerDetailsLibraryService };
//# sourceMappingURL=petitioner-details-library.js.map
